import Header from "@/types/app/header";

export default class CustomerAproovedHeader {
  public static header: Header[] = [
    {
      text: "Date of interest",
      align: "start",
      sortable: true,
      value: "dateInterest",
      class: "item-table-header item-table-header-date",
      width: ""
    },
    {
      text: "Name",
      align: "start",
      sortable: true,
      value: "fullName",
      class: "item-table-header item-table-header-refused",
      width: ""
    },
    {
      text: "Fund",
      align: "start",
      sortable: true,
      value: "title",
      class: "item-table-header item-table-header-refused",
      width: ""
    },
    {
      text: "Indicative interest",
      align: "start",
      sortable: true,
      value: "amount",
      class: "item-table-header item-table-header-amount",
      width: ""
    },
    {
      text: "Status",
      align: "start",
      sortable: true,
      value: "status",
      class: "item-table-header item-table-header-refused",
      width: ""
    },
    {
      text: "", align: "right", value: "actions", sortable: false, class: null,
      width: "" }
  ];
}
